import { SocketContext } from "providers/socket.provider";
import React, { useContext, useEffect, useState } from "react";

const useSocket = () => {
    const context = useContext(SocketContext);

    if (!context) {
        throw new Error("useSocket must be used within a SocketProvider");
    }

    const socket = context.socket;
    const [isConnected, setIsConnected] = useState(socket?.connected || false);

    useEffect(() => {
        if (!socket) return;

        const onConnect = () => setIsConnected(true);
        const onDisconnect = () => setIsConnected(false);

        socket.on("connect", onConnect);
        socket.on("disconnect", onDisconnect);

        return () => {
            socket.off("connect", onConnect);
            socket.off("disconnect", onDisconnect);
        };
    }, [socket]); // Depend on socket instance itself

    return { isConnected, socket };
};

export default useSocket;
